export const URL_PATTERN = new RegExp(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i);
export const PDF_PATTERN = new RegExp(/\.pdf$/i);
export const IMAGE_PATTERN = new RegExp(/\.(png|jpeg|jpg)$/i);
export const EMAIL_PATTERN = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/);
export const PASSWORD_PATTERN = new RegExp(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[+!@#$%^&*(),.?":{}|<>])[A-Za-z\d+!@#$%^&*(),.?":{}|<>]{8,}$/
);
